module.exports = __webpack_public_path__ + "static/media/HAUX_TRAINING_GUIAS_ALONGAMENTO.bff3d1f5.pdf";